import { useEffect } from "react";
import { injectJsonLd } from "../utils/head";

export function SiteWideStructuredData() {
  useEffect(() => {
    const cleanups = [
      injectJsonLd({
        "@context":"https://schema.org",
        "@type":"Organization",
        "name":"Prediedge",
        "url":"https://prediedge.com",
        "logo":"https://prediedge.com/PrediEdge.png",
        "sameAs":[
          "https://twitter.com/prediedge",
          "https://linkedin.com/company/prediedge"
        ]
      }, "org"),

      injectJsonLd({
        "@context":"https://schema.org",
        "@type":"SoftwareApplication",
        "name":"Prediedge",
        "applicationCategory":"FinanceApplication",
        "operatingSystem":"Web",
        "url":"https://prediedge.com",
        "description":"Prediedge is a prediction market analytics platform providing dashboards, whale tracking, and flow trading insights."
      }, "software-app"),

      injectJsonLd({
        "@context":"https://schema.org",
        "@type":"WebSite",
        "url":"https://prediedge.com",
        "name":"Prediedge",
        "potentialAction":{
          "@type":"SearchAction",
          "target":"https://prediedge.com/?s={search_term_string}",
          "query-input":"required name=search_term_string"
        }
      }, "website")
    ];

    return () => cleanups.forEach(fn => fn());
  }, []);

  return null;
} 